import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UserCredentials } from '../../store/authentication/model/user-credentials.model';
import { User } from '../../store/authentication/model/user.model';
import { UserSignUp } from '../../models/authentication/user-sign-up.model';

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {
    constructor(private http: HttpClient) {}

    signIn(data: UserCredentials): Observable<User> {
        return this.http.post<User>(`${environment.host}/authentication/login`, {
            email: data.email,
            password: data.password
        });
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    signOut(): Observable<any> {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return this.http.get<any>(`${environment.host}/authentication/logout`);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    resetPassword(data: { email: string }): Observable<any> {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return this.http.post<any>(`${environment.host}/authentication/lostPassword`, data);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    signUp(userData: UserSignUp): Observable<any> {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return this.http.post<any>(`${environment.host}/authentication/signup`, userData);
    }
}
